import React from "react";
import { ReviewCard } from "client/components/ChaptersOrderLayout/LowTaxBrokerAccount/sharedComponents/ReviewCard/ReviewCard";
import { ReviewField } from "client/components/ChaptersOrderLayout/LowTaxBrokerAccount/sharedComponents/ReviewField/ReviewField";
import { ReviewSectionTitle } from "client/components/ChaptersOrderLayout/LowTaxBrokerAccount/sharedComponents/ReviewSectionTitle/ReviewSectionTitle";
import { withTranslationReady } from "common/i18n/withTranslationReady";
import { WithTranslation } from "react-i18next";
import { ReviewFieldList } from "client/components/ChaptersOrderLayout/LowTaxBrokerAccount/sharedComponents/ReviewFieldList/ReviewFieldList";
import { CompanyData } from "lib/models/client/CompanyData";

export interface ReviewCompanyInformationProps {
  companyData: Partial<CompanyData>;
  editLink: string;
  className?: string;
}

const ReviewCompanyInformation = ({
  t,
  companyData,
  editLink,
  className = ""
}: ReviewCompanyInformationProps & WithTranslation) => {
  const { companyName, registerCourt, registration, leiNumber } = companyData;

  return (
    <ReviewCard className={className} dataTestId="company-information">
      <ReviewSectionTitle
        title={t("generic:ride-broker-onboarding.chapters.company-information")}
        editLink={editLink}
        isCompleted={true}
      />
      <ReviewFieldList>
        <ReviewField
          name="company-name"
          label={t("generic:add-existing-company.company-details.company-basic-info.company-name")}
          value={companyName}
        />
        <ReviewField
          name="register-court"
          label={t(
            "generic:add-existing-company.company-details.company-basic-info.register-court"
          )}
          value={registerCourt}
        />
        <ReviewField
          name="registration"
          label={t("generic:add-existing-company.company-details.company-basic-info.hrb")}
          value={registration}
        />
        <ReviewField
          name="lei-number"
          label={t("generic:add-existing-company.company-details.company-basic-info.lei")}
          value={leiNumber}
        />
      </ReviewFieldList>
    </ReviewCard>
  );
};

export default withTranslationReady(["generic"])(ReviewCompanyInformation);
